import { QuaTrinhDaoTaoResponse } from "../daotao/QuaTrinhDaoTao";
import { TimKiemToBanResponse } from "../toban/ToBan";
import { ChungChi } from "./ChungChi";
import { DangVien, DangVienResponse } from "./DangVien";
import { DoanVien, DoanVienResponse } from "./DoanVien";
import { KhenThuong } from "./KhenThuong";
import { KyLuat } from "./KyLuat";
import { NguoiPhuThuoc } from "./NguoiPhuThuoc";
import { QuaTrinhCongTac } from "./QuaTrinhCongTac";
import { DanhGiaXepLoai, QuaTrinhLamViec, QuaTrinhLamViecReponse } from "./QuaTrinhLamViec";
import { QuanDoi } from "./QuanDoi";
import { TaiLieu } from "./TaiLieu";
import { TrinhDoHocVan, TrinhDoHocVanResponse } from "./TrinhDoHocVan";

export class TimKiemNhanVienPagingResponse {
    "data": Array<NhanVienResponse>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class LuuAnhDaiDienResponse {
    "id": number;
    "avatar": string;
}

export class NhanVienResponse {
    "id": number;
    "ma": string;
    "hoTen": string;
    "tenDonVi": string;
    "idDonVi": number;
    "dienThoai": string;
    "email": string;
    "tenChucVu": string;
    "ngaySinh": Date | null;
    "gioiTinh": number;
    "isKetHon": number;
    "avatar": string;
    "tenHocHam": string;
    "tenTonGiao": string;
    "tenDanToc": string;
    "tenQuocTich": string;
    "tenChucDanhChuyenMon": string;
    "tenTrinhDoVanHoa": string;
    "tenTrinhDoLLCT": string;
    "tenPhuongXaThuongTru": string;
    "tenPhuongXaNoiO": string;
    "tenTinhThanhThuongTru": string;
    "tenTinhThanhNoiO": string;
    "chungChis": Array<ChungChi>;
    "ttDangVien": DangVienResponse;
    "ttDoanVien": DoanVienResponse;
    "khenThuongs": Array<KhenThuong>;
    "danhGiaXepLoais": Array<DanhGiaXepLoai>;
    "kyLuats": Array<KyLuat>;
    "ttQuanDoi": QuanDoi;
    "quaTrinhLamViecs": Array<QuaTrinhLamViecReponse>;
    "trinhDoHocVans": Array<TrinhDoHocVanResponse>;
    "cccd": string;
    "ngayCapCCCD": Date;
    "noiCapCCCD": string;
    "queQuan": string;
    "noiSinh": string;
    "isQuanNhan": boolean;
    "isDoanVien": boolean;
    "isDangVien": boolean;
    "soTKNganHang": string;
    "tenNganHang": string;
    "maSoThue": string;
    "chiNhanhNganHang": string;
    "soNhaNoiO": string;
    "soNhaThuongTru": string;
    "idChucVu": number;
    "idChucDanhChuyenMon": number;
    "idDanToc": number;
    "idNhom": number;
    "idTrinhDoVanHoa": number;
    "idQuocTich": number;
    "idTrinhDoLLCT": number;
    "idTonGiao": number;
    "idPhuongXaThuongTru": number;
    "idPhuongXaNoiO": number;
    "idTinhThanhThuongTru": number;
    "idTinhThanhNoiO": number;
    "quaTrinhCongTacs": Array<QuaTrinhCongTac>;
    "toBans": Array<TimKiemToBanResponse>;
    "quaTrinhDaoTaos": Array<QuaTrinhDaoTaoResponse>;
    "nguoiPhuThuocs": Array<NguoiPhuThuoc>;
    "dsTaiLieuNguoiPhuThuocs": Array<TaiLieu>;
    "fileHoSoCaNhan": TaiLieu;
    "soBHXH": string;
    "tenNhomNhanSu": string;
    "ngayVaoLam": Date;
    "ngayTinhPhep": Date;
    "soThangLamCQNN": number;
    "trangThai": number;
    "ngayNghiViec": Date;
    "tenNhomLyDoNghiViec": string;
    "idNhomLyDoNghiViec": number;
    "lyDoNghiViecCuThe": string;
    "luongs": LuongResponse;
    "isLanhDaoPhong": boolean;
    "thuTu": number;
}

export class NhanVienRequest {
    "id": number | null;
    "ma": string;
    "hoTen": string;
    "idDonVi": number | null;
    "dienThoai": string;
    "email": string;
    "tenChucVu": string;
    "ngaySinh": Date;
    "gioiTinh": number | null;
    "isKetHon": number | null;
    "chungChis": Array<ChungChi>;
    "ttDangVien": DangVien;
    "ttDoanVien": DoanVien;
    "khenThuongs": Array<KhenThuong>;
    "kyLuats": Array<KyLuat>;
    "ttQuanDoi": QuanDoi;
    "quaTrinhLamViecs": Array<QuaTrinhLamViec>;
    "trinhDoHocVans": Array<TrinhDoHocVan>;
    "cccd": string;
    "ngayCapCCCD": Date;
    "noiCapCCCD": string;
    "queQuan": string;
    "noiSinh": string;
    "isQuanNhan": boolean;
    "isDoanVien": boolean;
    "isDangVien": boolean;
    "soTKNganHang": string;
    "tenNganHang": string;
    "chiNhanhNganHang": string;
    "soNhaNoiO": string;
    "soNhaThuongTru": string;
    "idChucVu": number | null;
    "idChucDanhChuyenMon": number | null;
    "idDanToc": number | null;
    "idNhom": number | null;
    "idTrinhDoVanHoa": number | null;
    "idQuocTich": number | null;
    "idTrinhDoLLCT": number | null;
    "idTonGiao": number | null;
    "idPhuongXaThuongTru": number | null;
    "idPhuongXaNoiO": number | null;
    "idTinhThanhThuongTru": number | null;
    "idTinhThanhNoiO": number | null;
    "quaTrinhCongTacs": Array<QuaTrinhCongTac>;
    "quaTrinhDaoTaos": Array<QuaTrinhDaoTaoResponse>;
    "soBHXH": string;
    "tenNhomNhanSu": string;
}

export class NhanVienTheoDonViResponse {
    "id": number | null;
    "ten": string;
    "idDVCha": number;
    "thuTu": number;
    "ma": string;
    "nhanViens": Array<NhanVienResponse>;
    "children": Array<NhanVienTheoDonViResponse> | null;
}

export class TimKiemNhanVienRequest {
    "idDonVi": number | null;
    "tuKhoa": string;
    "ngaySinh": Date;
    "idChucVu": number | null;
    "idHocHam": number | null;
    "idNhomNhanSu": number | null;
    "maNhanVien": string;
    "soDienThoai": string;
    "ten": string;
    "email": string;
    "idChucDanh": number | null;
    "gioiTinh": number | null;
    "isKetHon": number | null;
    "idTrinhDoLLCT": number | null;
    "isDangVien": number | null;
    "isQuanNhan": number | null;
    "ngayVaoLam_TuNgay": Date | null;
    "ngayVaoLam_DenNgay": Date | null;
    "ngayBatDauQTLV_TuNgay": Date | null;
    "ngayBatDauQTLV_DenNgay": Date | null;
    "ngayKetThucQTLV_TuNgay": Date | null;
    "ngayKetThucQTLV_DenNgay": Date | null;
    "idLoaiQuyetDinh": number | null;
    "daoTao_NgayBatDau_TuNgay": Date | null;
    "daoTao_NgayBatDau_DenNgay": Date | null;
    "daoTao_NgayKetThuc_TuNgay": Date | null;
    "daoTao_NgayKetThuc_DenNgay": Date | null;
    "daoTao_Ten": string;
    "chungChi_NgayBatDau_TuNgay": Date | null;
    "chungChi_NgayBatDau_DenNgay": Date | null;
    "chungChi_NgayKetThuc_TuNgay": Date | null;
    "chungChi_NgayKetThuc_DenNgay": Date | null;
    "chungChi_Ten": string;
    "danhGia_Nam": number | null;
    "danhGia_KetQua": number | null;
    "khenThuong_ThanhTich": string;
    "khenThuong_NgayQuyetDinh_TuNgay": Date | null;
    "khenThuong_NgayQuyetDinh_DenNgay": Date | null;
    "kyLuat_NoiDung": string;
    "kyLuat_NgayQuyetDinh_TuNgay": Date | null;
    "kyLuat_NgayQuyetDinh_DenNgay": Date | null;
    selectedColumns?: string[] | null;
    "trangThai"?: number | null;
    "tenChuyenNganhDaoTao"?: string | null;
}
export class TimKiemNhanVienHopDongRequest {
    "idDonVi": number | null;
    "tuKhoa": string;
    "idLoaiHopDong":  number | null;
}

export class LuongResponse {
    "bacLuong": string;
    "heSo": number;
    "mucLuongThucNhan": number;
    "mucPhuCap": number;
}
export class ThongKeTrinhDoResponse {
    "id": number;
    "ten": string;
    "soLuongNhanVien": number
}
export class ThongKeNhanVienResponse {
    "thongKeTrinhDoResponse": Array<ThongKeTrinhDoResponse>;
    "tongNhanVienNam": number;
    "tongNhanVienNu": number;
}
export class NhanVienTheoThamNienCongTacResponse {
    "id": number;
    "hoTen": string;
    "ngaySinh": Date | null;
    "idChucVu": number;
    "tenChucVu": string;
    "idDonVi": number;
    "tenDonVi": number;
    "ngayVaoLam": Date | null;
    "tenNhomNhanSu": string;
    "loaiQuanLy": number;
    "soNamThamNienQuy": number | null;
    "soThangThamNienQuy": number | null;
    "stt": string
    "isTieuDe": boolean;
    "thoiGianVaoLamTaiPhongBan": Date | null;
    "soNamPhongban": number | null;
    "soThangPhongBan": number | null;
    "thoiGianBatDauDiLam": Date | null;
    "soNamDiLam": number | null;
    "soThangDiLam": number | null;
}

export interface ThongKeNhanSuResponse {
    idDonVi: number;
    tenDonVi: string;
    idChucVu?: number;
    tenChucVu?: string;
    soLuongNhanVien: number;
    soLuongNam: number;
    soLuongNu: number;
}

export interface ThongKeNhanSuDoanDangResponse {
    idDonVi: number;
    tenDonVi: string;
    idChucVu?: number;
    tenChucVu?: string;
    soLuongNhanVien: number;
    soLuongDoanVienTruongThanh: number;
    soLuongDoanVienChuaTruongThanh: number;
    soLuongDangVienDuBi: number;
    soLuongDangVienChinhThuc: number;
}

export interface ThongKeNhanSuDoanDangRequest {
    ngayThongKe: string | null;
}